import { createContext } from 'react'

const ConsentContext = createContext()

export default ConsentContext
